// @flow

import type {
  AssetsById,
} from 'fc-model-assets/types'

// Libs
import { createSelector } from 'reselect'

// Utils
import buildAncestorsIndex from '../utils/buildAncestorsIndex'

// Selectors
import assets$ from './assets'

// Exports
export default (createSelector(
  [assets$],
  function (assets: AssetsById): {[number]: Array<number>} {
    return buildAncestorsIndex(assets)
  }
): Selector$<{[number]: Array<number>}>)
